<div class="text-center mb-xl padding-manutencao">
    <div class="text-lg mb-lg">👨‍🔧</div>
    <p class="lead m0">{{'geral.manutencao.titulo' | translate}}</p>
    <p>{{'geral.manutencao.subtitulo' | translate}}
    </p>
</div>